import { createAuthClient } from "better-auth/react";
import { organizationClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  plugins: [organizationClient()],
  fetchOptions: {
    credentials: "include",
  },
});

export const { useSession } = authClient;

const buildAuthUrl = (path: string): string => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return new URL(`/api/auth${normalizedPath}`, window.location.origin).toString();
};

const buildHeaders = (hasBody: boolean): HeadersInit =>
  hasBody ? { "Content-Type": "application/json" } : {};

export async function betterAuthRequest<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const response = await fetch(buildAuthUrl(path), {
    credentials: "include",
    ...init,
    headers: {
      ...buildHeaders(Boolean(init.body)),
      ...(init.headers ?? {}),
    },
  });

  if (!response.ok) {
    let message = `${response.status} ${response.statusText}`;

    try {
      const payload = await response.json();
      if (typeof payload?.message === "string") {
        message = payload.message;
      } else if (typeof payload?.error === "string") {
        message = payload.error;
      } else if (typeof payload?.error?.message === "string") {
        message = payload.error.message;
      }
    } catch {
      // Ignore parsing errors for non-JSON responses.
    }

    throw new Error(message);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return response.json() as Promise<T>;
}
